export default {
    audit: {
        title: 'Audit log',
        recentEvents: 'Nedavni događaji',
        search: 'Pretraži audit log',
        dataChanged: 'Podaci',
        paginationRecentEvents: 'nedavnih događaja'
    },
    aboutPage: {
        description: 'O nama tekst',
        placeholder: 'Unesite tekst',
        update: 'Sačuvaj',
        latitude: 'Geografska širina (lat)',
        longitude: 'Geografska dužina (lon)',
        help: 'Koordinate možete generisati na ',
        location: 'Lokacija',
        successSaveMessage: 'Stranica je uspješno ažuriran!'
    },
    storePage: {
        title: 'Fotografije za stranicu prodavnice',
        featuredCollections: 'Izabrane kolekcije',
        firstCollection: 'Prva izabrana kolekcija',
        secondCollection: 'Druga izabrana kolekcija',
        logo: 'Logo',
        cover: 'Naslovna fotografija',
        footer: 'Footer',
        edit: 'Izmijeni',
        cancel: 'Poništi',
        upperSliderImages: 'Fotografije gornjeg slajdera',
        bottomSliderImages: 'Fotografije donjeg slajdera',
        maxImages: 'max 5 fotografija',
        save: 'Sačuvaj',
        successMessage: 'Fotografija je uspješno izbrisana!',
        resizeModal: {
            title: 'Isijeci fotografiju'
        },
        deviceModal: {
            title: 'Fotografije za uređaje',
            default: 'Podrazumijevana',
            tablet: 'Tablet',
            mobile: 'Mobilni telefon'
        },
        idealDimensions: 'Idealne dimenzije',
        idealDimensionsForTablet: 'Idealne dimenzije za tablet su',
        idealDimensionsForMobile: 'a za mobilni telefon',
        aspectRatio: 'aspect ratio'
    },
    storeCategories: {
        title: 'Kategorije',
        update: 'Ažuriraj',
        successSaveMessage: 'Kategorije prodavnice su uspješno ažurirane!',
    },
    payment: {
        title: 'Plaćanje karticom',
        requestBtn: 'Zahtjevaj',
        request: 'Zahtjevaj opciju naplate kreditnom karticom',
        requested: 'Zahtjev za opciju naplate kreditnom karticom se obrađuje.',
        paymentTypeCreditCard: 'Naplata proizvoda se vrši putem',
        paymentTypeCreditCard2: 'kreditne kartice.',
        denied: 'Zahtjev za opciju naplate kreditnom karticom je odbijen. Ukoliko imate nekih pitanja kontaktirajte nas na',
        creditCard: 'Kreditna kartica',
        cashOnDelivery: 'Pouzećem'
    },
    storeDescription: {
        title: 'Opis',
        update: 'Ažuriraj',
        placeholder: 'Unesi opis prodavnice',
        successSaveMessage: 'Opis prodavnice je uspješno ažuriran!'
    },
    storeOgImage: {
        title: 'OG Fotografija',
        update: 'Ažuriraj',
        successSaveMessage: 'OG fotografija je uspješno ažurirana!'
    },
    addresses: {
        title: 'Adrese',
        subtitle: 'Lista svih lokacija',
        addAddressButton: 'Dodaj novu adresu',
        successSaveMessage: 'Adresa je uspješno sačuvana!',
        successDeleteMessage: 'Adresa je uspješno izbrisana!',
        modal: {
            addAddress: {
                title: 'Nova adresa',
                button: {
                    close: 'Zatvori',
                    addAddress: 'Dodaj novu adresu'
                },
                input: {
                    address: {
                        title: 'Adresa',
                        placeholder: 'Unesi novu adresu'
                    },
                    addressNumber: {
                        title: 'Broj',
                        placeholder: '123'
                    },
                    city: {
                        title: 'Grad',
                        placeholder: 'Unesi grad u kojem je ova adresa'
                    }
                }
            },
            editAddress: {
                title: 'Izmijenite adresu',
                button: {
                    close: 'Zatvori',
                    updateAddress: 'Sačuvaj adresu'
                }
            }
        }
    },
    deleteStore: {
        title: "Obriši prodavnicu",
        warningMessage: "Jednom kada izbrišete prodavnicu, nema povratka. Molimo vas budite sigurni.",
        button: "Obriši prodavnicu",
        cancel: "Otkaži",
        modal: {
            title: "Da li ste sigurni da želite da uradite ovo?",
            deleteDataWarning: "Odmah ćemo izbrisati sve podatke prodavnice, uključujući podatke o vašim proizvodima, kolekcije, slike, adrese, porudžbine, komentare, ocjene.",
            nameLabel: "Naziv prodavnice"
        }
    },
    apiTokens: {
        title: 'Api tokeni',
        create: 'Kreiraj token',
        headers: {
            name: 'Name',
            token: 'Token'
        },
        successMessage: 'Uspješno kopiran token'
    },
    language: {
        title: 'Jezik'
    }
};
